import {
	UnsignedByteType,
	ByteType,
	ShortType,
	UnsignedShortType,
	IntType,
	UnsignedIntType,
	FloatType,
	HalfFloatType,
	UnsignedShort4444Type,
	UnsignedShort5551Type,
	UnsignedShort565Type,
	UnsignedInt248Type,
} from 'three/src/constants';

export const TEXTURE_TYPES = [
	{UnsignedByteType},
	{ByteType},
	{ShortType},
	{UnsignedShortType},
	{IntType},
	{UnsignedIntType},
	{FloatType},
	{HalfFloatType},
	{UnsignedShort4444Type},
	{UnsignedShort5551Type},
	{UnsignedShort565Type},
	{UnsignedInt248Type},
];
